import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IPbiReport } from '../../PowerBI/business-objects/types';

// types
export enum DashboardActionTypes {
  GET_MY_REPORTS = 'GET_MY_PINNED_REPORTS',
}

export const getMyPinnedReports = (url: string, locationId: number) => (
  dispatch
) =>
  new Promise(function (resolve, reject) {
    Api.get(url + '?locationId=' + locationId)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data));
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceResults = (result: IPbiReport[]) => {
  return {
    type: DashboardActionTypes.GET_MY_REPORTS,
    value: result,
  };
};
